// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfn_a"};